import {InsuranceCompanyService} from '../../../../../services/insurance-company.service';
import {FilterOption} from './offers-filter.model';
import * as _ from 'lodash';

export class FiltersDefinitionBase {

    insuranceCompanyService: InsuranceCompanyService;
    translationsContainer: string;

    constructor(insuranceCompanyService: InsuranceCompanyService,
                translationsContainer: string) {
        this.insuranceCompanyService = insuranceCompanyService;
        this.translationsContainer = translationsContainer;
    }

    protected createInsuranceCompaniesOptions(): FilterOption[] {
        const filterOptions = this.insuranceCompanyService.getInsuranceCompaniesForFilters()
            .map(config => ({
                key: config.code,
                label: config.name,
                translate: false
            }));
        return _.sortBy(filterOptions, [(option: FilterOption) => option.label.toLowerCase()]);
    }
}
